<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="text-right mb-2">

        </div>
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex justify-space-between">
                            <h3>เบิกของ โซน {{ zone.name }}</h3>
                            <div>วันที่ {{ new Date().getDate() +' '+ $store.state.monthList[new Date().getMonth()].name +' '+ `${new Date().getFullYear() + 543}`}}</div>
                        </div>
                        <div class="mt-2">
                            <v-form @submit.prevent="materialWithdraw()">
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="text-center border_header_add_lotout_list">
                                                รายการ
                                            </th>
                                            <th class="text-center border_header_add_lotout_list">
                                                ราคาต้นทุน
                                            </th>
                                            <th class="text-center border_header_add_lotout_list">
                                                คงเหลือในคลัง
                                            </th>
                                            <th class="text-center border_header_add_lotout_list">
                                                เบิก
                                            </th>
                                            <th class="text-center border_header_add_lotout_list">
                                                เบิกแล้ว
                                            </th>
                                            <th class="text-center border_header_add_lotout_list">
                                                หน่วยนับ
                                            </th>
                                            <th class="text-center border_header_add_lotout_list">
                                                มูลค่ารวม (บาท)
                                            </th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        <tr v-for="(out_zone_detail,index) in out_zone" :key="index">
                                            <td class="text-center border_header_add_lotout_list" width="20%">{{ out_zone_detail.mat_name }}</td>
                                            <td class="text-center border_header_add_lotout_list" width="20%">
                                                {{ out_zone_detail.mat_price }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_list">
                                                {{ currencyFormat(out_zone_detail.remain_stock) }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_list pt-2 pb-2" width="10%">
                                                <div>
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="out_zone_detail.amount" hide-details="auto" dense outlined></v-text-field>
                                                </div>
                                            </td>
                                            <td class="text-center border_header_add_lotout_list pt-2 pb-2" width="10%">
                                                <v-tooltip bottom color="primary" v-model="out_zone_detail.show_question">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="border_bottom_add_lotout_list mr-1" v-bind="attrs" v-on="on" @click="openShowWithdrawn(out_zone_detail.lot_detail_id)">
                                                            {{ currencyFormat(out_zone_detail.quantity) }}
                                                        </div>
                                                    </template>
                                                    <span>คลิกเพื่อดูประวัติการเบิก</span>
                                                </v-tooltip>
                                                <v-icon @click="out_zone_detail.show_question = !out_zone_detail.show_question">mdi-help-circle</v-icon>
                                            </td>
                                            <td class="text-center border_header_add_lotout_list">
                                                {{ out_zone_detail.unit_name }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_list" width="20%">
                                                {{ currencyFormat((out_zone_detail.amount * out_zone_detail.mat_price) + (out_zone_detail.quantity * out_zone_detail.mat_price)) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right border_header_add_lotout_list" colspan="6">
                                                มูลค่ารวมทั้งหมด (บาท)
                                            </td>
                                            <td class="text-center border_header_add_lotout_list">
                                                {{
                                                    currencyFormat(out_zone.reduce((sum, number) => {
                                                         return sum + ((number.amount * number.mat_price) + (number.quantity * number.mat_price))
                                                    }, 0))
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center border_header_add_lotout_list pt-2 pb-2" colspan="7">
                                                <v-btn color="#28ab28" type="submit" class="white--text mr-1" width="20%" height="50" :disabled="amount_all > 0 ? false : true">
                                                    บันทึกการเบิก
                                                </v-btn>
                                                <v-btn color="#ff5252" type="button" class="white--text ml-1" @click="$router.push('/addlotoutsummarize')" width="20%" height="50">
                                                    ปิดยอดเบิกประจำวัน
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
                <v-dialog v-model="open_show_withdrawn" persistent max-width="600px">
                    <div v-if="loading_detail_page === true">
                        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                        </v-sheet>
                    </div>
                    <v-card v-if="loading_detail_page === false">
                        <v-card-title>
                            ประวัติการเบิก {{ out_zone_detail_list.mat_name }}
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table>
                                            <thead>
                                                <tr>
                                                    <th class="text-center border_header_add_lotout_list">
                                                        ผู้เบิก
                                                    </th>
                                                    <th class="text-center border_header_add_lotout_list">
                                                        จำนวน
                                                    </th>
                                                    <th class="text-center border_header_add_lotout_list">
                                                        หน่วยนับ
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(out_zone_detail_list_detail,index) in out_zone_detail_list.history" :key="index">
                                                    <td class="text-center border_header_add_lotout_list">
                                                        {{ out_zone_detail_list_detail.nickname }} {{ new Date(out_zone_detail_list_detail.created_at).getHours() }}:{{ new Date(out_zone_detail_list_detail.created_at).getMinutes() > 9 ? new Date(out_zone_detail_list_detail.created_at).getMinutes() : new Date(out_zone_detail_list_detail.created_at).getMinutes() +'0' }} น.
                                                    </td>
                                                    <td class="text-center border_header_add_lotout_list">
                                                        {{ currencyFormat(out_zone_detail_list_detail.quantity) }}
                                                    </td>
                                                    <td class="text-center border_header_add_lotout_list">
                                                        {{ out_zone_detail_list.unit_name }}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </v-simple-table>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" type="button" height="50" @click="open_show_withdrawn = false">
                                ยกเลิก
                            </v-btn>
                        </v-card-actions>

                    </v-card>
                </v-dialog>
            </div>
            <v-dialog v-model="open_alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        เบิกของโซน{{ zone.name }}เรียบร้อย
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="page_not_found" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        คำเตือน
                    </v-card-title>

                    <v-card-text>
                        ไม่มีวัตถุดิบในโซน {{ zone.name }}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="$router.push('/stockinout')">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</div>
</template>

<script>
import zoneall from '@/api/stock/stocklist/zoneall.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_detail_page: true,
            page_not_found: false,
            open_alert_show_add: false,
            open_show_withdrawn: false,
            zone: null,
            lot_id:null,
            out_zone: [],
            out_zone_detail_list: [],
        }
    },
    methods: {
        currencyFormat,
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async zoneDetail() {
            this.loading_page = true
            this.page_not_found = false
            this.out_zone = []
            await zoneall.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.zone = response.data.zone.find((detail) => {
                        return detail.id == this.$store.state.addLotinId
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await zoneall.outZoneList(this.zone.id).then((response) => {
                if (response.data.successful === true) {
                    
                    response.data.list.forEach((detail) => {
                        this.out_zone.push({
                            lot_detail_id: detail.lot_detail_id,
                            mat_id: detail.mat_id,
                            mat_name: detail.mat_name,
                            remain_stock: detail.remain_stock,
                            mat_price: detail.mat_price,
                            amount: '',
                            quantity: detail.quantity,
                            unit_name: detail.unit_name,
                            history: detail.history,
                            show_question:false,
                        })
                    })
                    this.lot_id = response.data.lot_id

                    if (response.data.status == 1) {
                        const idPage = {
                            id: response.data.lot_id
                        }
                        this.$store.commit('lotDetailOutPage', idPage)
                        this.$router.push('/lotdetailout')
                    }
                    this.loading_page = false
                }
                if (response.data.successful === false) {
                    this.page_not_found = true
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openShowWithdrawn(id) {
            this.loading_detail_page = true
            this.open_show_withdrawn = true
            this.out_zone_detail_list = this.out_zone.find((detail) => {
                return detail.lot_detail_id == id
            })
            this.loading_detail_page = false
        },
        async materialWithdraw() {
            if (this.amount_all > 0) {
                this.loading_page = true
                const withdraw = this.out_zone.filter((detail) => {
                    return detail.amount != ''
                })

                const mat_id = withdraw.map((detail) => {
                    return detail.mat_id
                })

                const lot_detail_id = withdraw.map((detail) => {
                    return detail.lot_detail_id
                })

                const quantity = withdraw.map((detail) => {
                    return parseFloat(detail.amount)
                })

                const total = withdraw.map((detail) => {
                    return (parseFloat(detail.amount) * parseFloat(detail.mat_price)) + (parseFloat(detail.quantity) * parseFloat(detail.mat_price))
                })

                const data = {
                    mat_id: mat_id,
                    lot_detail_id: lot_detail_id,
                    quantity: quantity,
                    total: total,
                }

                zoneall.materialWithdraw(data).then((response) => {
                    if (response.data.successful === true) {
                        this.open_alert_show_add = true
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async confirmSuccess() {
            this.open_alert_show_add = false
            this.zoneDetail()
        },
    },
    computed: {
        amount_all() {
            const amount_arr = this.out_zone.map((detail) => {
                return detail.amount != '' ? parseFloat(detail.amount) : 0
            })
            const amount = amount_arr.reduce((sum, number) => {
                return sum + number
            }, 0)

            return amount
        }
    },
    mounted() {
        this.zoneDetail()
    }
}
</script>

<style scoped>
.border_header_add_lotout_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.border_bottom_add_lotout_list {
    cursor: pointer;
    display: inline-block;
    border-bottom: 2px solid #000000;
}
</style>
